import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ITableServerResponseFilter } from 'src/app/common/interfaces/table/table-server-filter-response.interface';
import { ITableServerFilter } from 'src/app/common/interfaces/table/table-server-filter.inteface';
import { AbstractRtpCorrespondentReconService } from '../abstraction/abstract.correspondent-reconcilation.service';
import { IReconTransactions } from '../../interfaces/reconciliation/correspondent/correspondent-recon-transaction.interface';

@Injectable({
  providedIn: 'root',
})
export class RtpCorrespondentReconService extends AbstractRtpCorrespondentReconService {
  controller = `/manager/rtp/correspondentrecon`;
  urlGetCorrespondentReconGrid = `${environment.apiUrl}${this.controller}/grid`;
  urlGetCorrespondentReconExportExcel = `${environment.apiUrl}${this.controller}/gridExportExcel`;
  urlGetCorrespondentReconExportCSV = `${environment.apiUrl}${this.controller}/gridExportCSV`;
  urlGetRespondentReconciliationDetails = `${environment.apiUrl}${this.controller}/settlements`;
  constructor(private http: HttpClient) {
    super();
  }

  override tableFilter(
    filter: ITableServerFilter
  ): Promise<ITableServerResponseFilter | undefined> {
    return this.http
      .post<ITableServerResponseFilter>(`${this.urlGetCorrespondentReconGrid}`, filter)
      .toPromise();
  }

  override tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined> {
    return this.http
      .post(`${this.urlGetCorrespondentReconExportCSV}`, filter, {
        responseType: 'blob',
      })
      .toPromise();
  }

  override tableExportExcel(filter: ITableServerFilter): Promise<any> {
    return this.http.post(`${this.urlGetCorrespondentReconExportExcel}`, filter).toPromise();
  }

  override getReconciliationDetails(
    cycleDate: string,
    reconWindowId: number
  ): Promise<IReconTransactions[] | undefined> {
    return this.http
      .get<IReconTransactions[]>(
        `${this.urlGetRespondentReconciliationDetails}/${cycleDate}/${reconWindowId}`
      )
      .toPromise();
  }
}
